import React from 'react';
import { Link } from 'react-router-dom';
import NewsletterSubscribe from '@/components/NewsletterSubscribe';

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card mt-24">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <h3 className="font-serif text-xl font-bold mb-4">THE MODERN GALLERY</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Curated collection of original paintings and photo prints.
              Each piece tells a unique story.
            </p>
          </div>
          
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">EXPLORE</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/gallery" className="text-sm hover:text-accent transition-colors">
                Gallery
              </Link>
              <Link to="/about" className="text-sm hover:text-accent transition-colors">
                About the Artist
              </Link>
              <Link to="/gallery?category=painting" className="text-sm hover:text-accent transition-colors">
                Paintings
              </Link>
              <Link to="/gallery?category=photography" className="text-sm hover:text-accent transition-colors">
                Photography
              </Link>
              <Link to="/gallery/mature" className="text-sm hover:text-accent transition-colors">
                NSFW Collection (18+)
              </Link>
            </nav>
          </div>
          
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">CONNECT</h4>
            <p className="text-sm text-muted-foreground">
              Questions? Contact us at<br />
              <a href="mailto:hello@moderngallery.art" className="hover:text-accent transition-colors">
                hello@moderngallery.art
              </a>
            </p>
          </div>
        </div>
          
          <div>
            <NewsletterSubscribe />
          </div>
        
        <div className="mt-12 pt-8 border-t border-border text-center">
          <p className="text-xs text-muted-foreground">
            © 2026 The Modern Gallery. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}